import httpClient from 'api/core/httpClient';
import { ENDPOINTS } from 'api/config/endpoints';
import auth from 'api/core/auth';

class AuthApi {
  constructor() {
    this.httpClient = httpClient;
    this.resource = ENDPOINTS.AUTH;
  }

  getResourceUrl() {
    const companyDomain = auth.getCompanyDomain();

    return `${companyDomain}/${this.resource}/`;
  }

  async login(credentials) {
    return this.httpClient.post(`${this.getResourceUrl()}login/`, credentials);
  }

  async logout() {
    try {
      const response = await this.httpClient.get(
        `${this.getResourceUrl()}logout/`,
      );
      auth.clearAuth();
      return response;
    } catch (error) {
      auth.clearAuth();
      throw error;
    }
  }

  async passwordReset(data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}password-reset/`,
      data,
    );
  }

  async passwordResetConfirm(data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}password-reset/confirm/`,
      data,
    );
  }
}

export default new AuthApi();
